import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const AfficheResevationHistorique = async (idClient, page) => {
    return await axios.get(`${BASE_URL}/api/client/afficherHistoriqueReservation/${idClient}/${page}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenClient'),
        }
    });
}

const AfficheAvisDeposer = async (idClient, page) => {
    return await axios.get(`${BASE_URL}/api/client/afficherAvis/${idClient}/${page}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenClient'),
        }
    });
}

export { AfficheAvisDeposer, AfficheResevationHistorique }